import React, { SVGProps } from 'react';

export const Blimp = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="660"
      height="396"
      viewBox="0 0 660 396"
      fill="none"
      {...props}
    >
      <path
        d="M658.483 142.199C641.209 33.4448 500.906 -16.1 369.768 4.6177C301.782 15.3931 212.524 60.7167 143.705 111.039C141.484 107.929 137.818 104.152 132.097 101.819C121.321 97.4309 9.62339 89.5993 1.23631 107.762C-7.09521 125.814 28.8414 195.854 44.4492 212.35C39.4503 222.682 37.3396 232.18 38.6171 240.344C39.9502 248.676 44.8935 257.063 52.7252 265.339C43.005 286.112 30.5633 363.429 44.0604 377.981C57.6685 392.645 161.479 350.709 170.366 343.211C175.81 338.601 178.087 332.991 179.031 329.27C212.913 339.601 249.905 347.766 286.286 352.709L314.78 380.814C324.222 390.145 336.886 395.589 350.161 395.811C364.269 396.088 384.82 395.366 410.148 391.367C438.919 386.813 465.08 379.425 482.299 373.871C495.407 369.65 506.294 360.43 512.681 348.21L527.622 319.383C609.882 281.058 670.48 218.071 658.483 142.199ZM389.263 50.2745C498.906 32.8894 584.511 74.3485 613.227 124.06C574.125 111.174 517.791 95.598 399.872 114.261C285.675 132.368 183.03 169.027 118.711 197.409C165.756 149.531 274.177 68.4928 389.263 50.2745ZM416.98 304.886C299.561 323.493 172.755 279.003 118.711 249.953C187.974 255.341 302.615 258.229 419.757 239.678C519.069 223.959 585.234 195.656 620.781 171.772C607.118 226.649 527.567 287.334 417.035 304.83L416.98 304.886Z"
        fill="currentColor"
      />
    </svg>
  );
};
